import { useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const prefersReducedMotion = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  const query = window.matchMedia('(prefers-reduced-motion: reduce)');
  return Boolean(query && query.matches);
};

// Reveals every element marked with `data-reveal` inside the scoped ref as it
// scrolls into view. Elements may set `data-reveal-delay` (seconds) to stagger.
// Honours prefers-reduced-motion by skipping animation and showing content.
export function useScrollReveal(scopeRef, deps = []) {
  useLayoutEffect(() => {
    const scope = scopeRef.current;
    if (!scope) return undefined;

    const targets = Array.from(scope.querySelectorAll('[data-reveal]'));

    if (prefersReducedMotion() || process.env.NODE_ENV === 'test') {
      targets.forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return undefined;
    }

    const ctx = gsap.context(() => {
      targets.forEach((el) => {
        const delay = parseFloat(el.getAttribute('data-reveal-delay') || '0');
        gsap.fromTo(
          el,
          { opacity: 0, y: 42 },
          {
            opacity: 1,
            y: 0,
            duration: 0.85,
            delay,
            ease: 'power3.out',
            scrollTrigger: { trigger: el, start: 'top 88%', once: true },
          },
        );
      });
    }, scope);

    return () => ctx.revert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
